module.exports = __webpack_public_path__ + "img/ideation-2_cn.7328278.jpg";